import reducer from './reducers'
import * as modalOperations from './operations'

export { modalOperations }

export default reducer
